// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/siteStoreExecutionStyles.js
// =============================================================================

const executionStyles = {

  // ===========================================================================
  // COMMON SECTION
  // ===========================================================================

  section: {

    marginBottom: 28
  },

  sectionTitle: {

    fontSize: 16,

    fontWeight: 700,

    marginBottom: 16,

    color: "#111827"
  },

  // ===========================================================================
  // STATES
  // ===========================================================================

  loadingBox: {

    padding: 20,

    textAlign: "center",

    color: "#6b7280"
  },

  errorBox: {

    padding: 16,

    borderRadius: 10,

    background: "#fee2e2",

    color: "#991b1b",

    fontWeight: 500
  },

  emptyBox: {

    padding: 24,

    textAlign: "center",

    color: "#6b7280",

    border:
      "1px dashed #d1d5db",

    borderRadius: 12
  },

  // ===========================================================================
  // TABLE
  // ===========================================================================

  tableWrap: {

    overflowX: "auto",

    border:
      "1px solid #e5e7eb",

    borderRadius: 12,

    background: "#ffffff"
  },

  table: {

    width: "100%",

    borderCollapse: "collapse"
  },

  th: {

    background: "#f9fafb",

    padding: 14,

    textAlign: "left",

    fontSize: 13,

    fontWeight: 700,

    color: "#374151",

    borderBottom:
      "1px solid #e5e7eb"
  },

  td: {

    padding: 14,

    borderTop:
      "1px solid #f3f4f6",

    fontSize: 14,

    color: "#111827"
  },

  tdRight: {

    padding: 14,

    borderTop:
      "1px solid #f3f4f6",

    textAlign: "right",

    fontWeight: 700,

    color: "#111827"
  },

  // ===========================================================================
  // BADGES
  // ===========================================================================

  statusIssued: {

    background: "#ede9fe",

    color: "#6d28d9",

    padding: "6px 10px",

    borderRadius: 20,

    fontSize: 11,

    fontWeight: 700
  },

  statusConsumed: {

    background: "#cffafe",

    color: "#155e75",

    padding: "6px 10px",

    borderRadius: 20,

    fontSize: 11,

    fontWeight: 700
  },

  statusReturned: {

    background: "#dcfce7",

    color: "#166534",

    padding: "6px 10px",

    borderRadius: 20,

    fontSize: 11,

    fontWeight: 700
  },

  statusScrap: {

    background: "#fee2e2",

    color: "#991b1b",

    padding: "6px 10px",

    borderRadius: 20,

    fontSize: 11,

    fontWeight: 700
  }

};

export default executionStyles;